export default function WhyProgramsWork() {
  const cards = [
    { icon: 'ri-magic-line', title: 'Предварительная диагностика', desc: 'Перед тренингом изучаем реальные переговоры, данные CRM и проводим интервью с руководителями и менеджерами.' },
    { icon: 'ri-headphone-line', title: 'Анализ звонков', desc: 'Прослушиваем 20–30 записей разговоров. Выявляем системные и индивидуальные ошибки диагностики.' },
    { icon: 'ri-message-2-line', title: 'Изучение переписок', desc: 'Анализируем письменные коммуникации с клиентами: как менеджеры выявляют потребности в тексте.' },
    { icon: 'ri-team-line', title: 'Интервью с сотрудниками', desc: 'Беседуем с руководителями и менеджерами. Понимаем контекст: продукт, рынок, цикл сделки.' },
    { icon: 'ri-settings-3-line', title: 'Адаптация программы', desc: 'Каждая программа уникальна. Учитываем отрасль, продукт и текущий уровень навыков команды.' },
    { icon: 'ri-briefcase-line', title: 'Практика на кейсах клиента', desc: 'Все упражнения строятся на реальных сценариях компании — ни одного абстрактного примера.' },
    { icon: 'ri-file-search-line', title: 'Работа с реальными переговорами', desc: 'Разбираем записи участников прямо на тренинге. Это в десятки раз эффективнее теории.' },
    { icon: 'ri-gamepad-line', title: 'Авторские бизнес-игры', desc: 'Моделируем сложные переговорные ситуации в игровом формате для глубокого усвоения навыков.' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Между модулями участники применяют навыки в работе. Результаты разбираем вместе.' },
    { icon: 'ri-road-map-line', title: 'Посттренинговое сопровождение', desc: 'После тренинга продолжаем работу: аудит, обратная связь, корректировка стратегии.' },
    { icon: 'ri-telegram-line', title: 'Разбор переговоров в Telegram', desc: 'Участники присылают записи сложных диалогов и получают экспертный разбор.' },
    { icon: 'ri-survey-line', title: 'Контроль внедрения', desc: 'Через 1–3 месяца проводим контрольный срез: как изменилось качество диагностики и конверсия.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-shield-check-line"></i>
            Не стандартные тренинги
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему наши программы работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Мы строим обучение иначе. Не просто проводим семинар — а сопровождаем внедрение изменений на каждом этапе.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-16">
          {cards.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50/50 transition-colors group border border-transparent hover:border-teal-100">
              <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-focus-2-line text-3xl text-white"></i>
          </div>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Мы обучаем не абстрактным продажам. Мы внедряем изменения в конкретной компании.
          </p>
        </div>
      </div>
    </section>
  );
}